import { useCallback } from "react"
import api from "../../../services/api"
import toastError from "../../../errors/toastError"

/**
 * Hook para encaminhar uma mensagem utilizando o backend.
 * Backend: POST /messages/:mensagemId/encaminhar
 *
 * Parâmetros:
 *  - oMensagem: objeto da mensagem original (deve conter id e ticketId)
 *  - mContatos: array com contatos ou ids dos contatos selecionados
 */
export default function useHandleEncaminharMensagem() {
  const handleForward = useCallback(async ({ oMensagem, mContatos }) => {
    try {
      // Validações mínimas
      if (!oMensagem?.id || !oMensagem?.ticketId) {
        throw new Error("Mensagem inválida")
      }
      if (!Array.isArray(mContatos) || mContatos.length === 0) {
        throw new Error("Informe ao menos um contato")
      }

      // Extrai de mContatos os contatos de usuarios e descarta eles do mContatos
      const mUsuarios = mContatos.filter((oContato) => {
        return oContato?.canalTipoId === 1 && oContato?.tipo === "usuario"
      })

      // Extrai apenas os IDs dos contatos e monta string exigida pelo backend.
      // Quando a linha representa uma conversa em conexão específica, envia id:canalId.
      const mContatosIds = mContatos
        .filter((oContato) => !(oContato?.canalTipoId === 1 && oContato?.tipo === "usuario"))
        .map((oContato) => {
          if (typeof oContato !== "object") {
            return oContato
          }
          if (oContato?.canalId != null && oContato?.canalId !== "") {
            return `${oContato.id}:${oContato.canalId}`
          }
          return oContato?.id
        })
        .filter(Boolean)

      // Extrai os ids dos usuarios
      const mUsuariosIds = mUsuarios
        .map((oUsuario) => (typeof oUsuario === "object" ? oUsuario?.id : oUsuario))
        .filter(Boolean)

      const cContatos = mContatosIds.join(",")
      const cUsuarios = mUsuariosIds.join(",")

      if (cContatos === "" && cUsuarios === "") {
        throw new Error("Nenhum contato válido para encaminhamento")
      }

      // Chama o endpoint de encaminhamento
      await api.post(`/messages/${encodeURIComponent(oMensagem.id)}/encaminhar`, {
        conversaId: String(oMensagem.ticketId),
        contatos: cContatos,
        usuarios: cUsuarios,
      })
    } catch (err) {
      toastError(err)
      throw err
    }
  }, [])

  return handleForward
}